export default {
  hero: {
    title: '성공 사례',
    subtitle: '복잡한 비즈니스 과제를 해결하고 디지털 전환과 성장을 실현한 고객 프로젝트를 살펴보세요',
    imageAlt: '사례 소개 배경 이미지'
  },
  filter: {
    title: '이중 조건 사례 필터',
    regionTitle: '지역별 필터',
    industryTitle: '산업별 필터',
    currentFilter: '현재 필터',
    clearAll: '전체 초기화',
    regions: {
      all: '전체 지역',
      china: '중국 본토',
      hongkong: '중국 홍콩',
      taiwan: '중국 대만',
      japan: '일본',
      korea: '한국',
      singapore: '싱가포르',
      america: '미주',
      europe: '유럽'
    },
    industries: {
      all: '전체 산업',
      manufacturing: '제조',
      finance: '금융',
      healthcare: '헬스케어',
      retail: '리테일 및 이커머스',
      government: '정부 및 공공 부문',
      professional: '전문 서비스'
    }
  },
  caseList: {
    resultCount: '검색 결과',
    projectBackground: '프로젝트 배경',
    implementation: '구현 내용',
    loadMore: '사례 더 보기',
    loading: '불러오는 중...',
    noMore: '더 이상 사례가 없습니다'
  },
  cases: {
    case1: {
      regionLabel: '일본',
      industryLabel: '제조',
      title: '일본 제조기업 하이브리드 클라우드 전환',
      background: '전 세계 12,000명의 직원을 보유하고 중국, 태국, 미국에 생산 거점을 운영하는 일본의 대형 자동차 부품 제조기업입니다. 지역 간 데이터 동기화 지연, 높은 유지보수 비용, 부족한 비즈니스 연속성 문제가 있어 효율적이고 안전한 하이브리드 클라우드 아키텍처가 필요했습니다.',
      implementation: [
        '중국-일본 간 하이브리드 클라우드 아키텍처 설계 및 구축',
        '핵심 업무 시스템의 AWS 클라우드 이전',
        '분산 데이터 동기화 및 재해 복구 체계 구축',
        '네트워크 아키텍처 재설계 및 글로벌 가속 최적화',
        '24x7 글로벌 운영 지원 체계 수립'
      ],
      metrics: [
        { value: '40%', label: '시스템 응답 속도 향상' },
        { value: '25%', label: '운영 비용 절감' },
        { value: '100%', label: '컴플라이언스 통과율' }
      ]
    },
    case2: {
      regionLabel: '싱가포르',
      industryLabel: '금융',
      title: '싱가포르 핀테크 기업 데이터 보안 고도화',
      background: '일일 500만 건 이상의 거래와 연간 150억 싱가포르 달러 규모의 거래를 처리하는 싱가포르 선도 결제 서비스 기업입니다. 강화되는 MAS 규제, 데이터 유출 위험, 국경 간 결제 보안 요구에 대응하기 위해 국제 기준에 부합하는 다층 보안 체계를 구축해야 했습니다.',
      implementation: [
        '종단 간 데이터 암호화 체계 구축(AES-256)',
        '다중 인증 및 권한 관리 체계 정비',
        '실시간 위협 탐지 및 보안 사고 대응 플랫폼 도입',
        'MAS 컴플라이언스 감사 준비 및 문서화',
        'DDoS 방어 및 API 보안 강화',
        '데이터 백업 및 재해 복구 체계 구축'
      ],
      metrics: [
        { value: '95%', label: '보안 사고 감소' },
        { value: '100%', label: 'MAS 컴플라이언스 감사 통과' },
        { value: '60%', label: '위협 대응 시간 단축' }
      ]
    },
    case3: {
      regionLabel: '한국',
      industryLabel: '헬스케어',
      title: '한국 의료기관 AI 진단 보조 플랫폼',
      background: '병상 수 1,200개, 연간 진료 건수 80만 건 이상의 서울 소재 대형 종합병원입니다. 영상 판독 전문의 부족, 인적 요인에 따른 진단 편차, 긴 대기 시간 문제를 해결하기 위해 AI 기반 진단 효율 향상이 필요했습니다.',
      implementation: [
        'AI 영상 분석 시스템 구축 및 맞춤형 학습',
        '의료 영상 데이터 라벨링 및 딥러닝 모델 최적화',
        '기존 PACS 시스템 연동 및 데이터 인터페이스 개발',
        '의료진 교육 및 AI 보조 진단 프로세스 설계',
        '진단 품질 관리와 AI 지속 개선 체계 수립'
      ],
      metrics: [
        { value: '35%', label: '진단 정확도 향상' },
        { value: '70%', label: '영상 처리 시간 단축' },
        { value: '42%', label: '환자 만족도 향상' }
      ]
    },
    case4: {
      regionLabel: '중국 홍콩',
      industryLabel: '리테일 및 이커머스',
      title: '홍콩 리테일 그룹 옴니채널 멤버십 및 재고 플랫폼',
      background: '오프라인 매장, 온라인 스토어, 멤버십 프로그램을 동시에 운영하는 홍콩 리테일 체인으로, 채널 간 재고 불일치, 분산된 주문 가시성, 분절된 고객 프로필, 낮은 재구매 분석 역량 문제를 해결하기 위해 통합 옴니채널 운영 플랫폼이 필요했습니다.',
      implementation: [
        '상품, 재고, 주문, 멤버십 마스터 데이터를 통합하는 옴니채널 미들 플랫폼 구축',
        '매장, 이커머스, 캠페인, 멤버십 데이터를 연결하는 고객 데이터 플랫폼 도입',
        '클라우드 POS, 모바일 결제, 매장 CRM 연동으로 현장 운영 효율 향상',
        '창고-매장 가시화 대시보드 구축으로 보충 및 이동 전략 최적화',
        '정밀 마케팅과 개인화 추천 흐름 연계로 고객 충성도 운영 강화'
      ],
      metrics: [
        { value: '32%', label: '재고 정확도 향상' },
        { value: '28%', label: '재구매율 증가' },
        { value: '41%', label: '품절률 감소' }
      ]
    },
    case5: {
      regionLabel: '중국 본토',
      industryLabel: '전문 서비스',
      title: '화동 컨설팅 기업 보안 지식 협업 플랫폼',
      background: '여러 도시에 프로젝트 제공 팀을 보유한 지역 컨설팅 그룹으로, 문서 버전 분산, 복잡한 고객 자료 권한 관리, 지연되는 시간 기록, 높은 원격 협업 수요 문제를 해결하기 위해 보안 협업과 청구, 지식 축적을 아우르는 통합 워크스페이스가 필요했습니다.',
      implementation: [
        '세분화된 권한과 감사 추적 기능을 갖춘 보안 문서 관리 플랫폼 구축',
        '분산 팀 협업을 위한 엔터프라이즈 회의 및 통합 커뮤니케이션 도구 연동',
        '시간 추적, 프로젝트 관리, 청구 시스템 연결로 청구 가능 시간 확보율 향상',
        '디지털 프로세스 자동화로 고객 온보딩, 계약 검토, 승인 절차 최적화',
        '검색 가능한 지식 태깅과 사례 아카이브 체계 수립'
      ],
      metrics: [
        { value: '68%', label: '문서 검색 효율 향상' },
        { value: '22%', label: '청구 가능 시간 확보율 향상' },
        { value: '45%', label: '고객 온보딩 기간 단축' }
      ]
    }
  },
  consultation: {
    title: '귀사에 맞는 솔루션을 찾고 계신가요?',
    description: '어떤 산업에 속해 있든, 어느 지역에서 운영하든 귀사에 맞는 디지털 전환 솔루션을 제안해 드립니다. 양식을 작성하고 무료 상담을 받아보세요.',
    button: '무료 상담 받기'
  }
}
